/// <amd-module name="TFS/Admin/Common/RestClient/TenantPolicy" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\tenantpolicy.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as TenantPolicy from "../Contracts/TenantPolicy";

export interface ITenantPolicyRestClient extends IVssRestClient {
    /**
     * @param policyName - 
     */
    getPolicy(policyName: string): Promise<TenantPolicy.Policy>;
    /**
     * @param policy - 
     * @param policyName - 
     */
    setPolicy(policy: TenantPolicy.Policy, policyName: string): Promise<void>;
    /**
     * @param policyName - 
     */
    getPolicyInfo(policyName: string): Promise<TenantPolicy.PolicyInfo>;
}

class TenantPolicyRestClient extends RestClientBase implements ITenantPolicyRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param policyName - 
     */
    public async getPolicy(
        policyName: string
        ): Promise<TenantPolicy.Policy> {

        return this.beginRequest<TenantPolicy.Policy>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "_apis/TenantPolicy/Policies/{policyName}",
            routeValues: {
                policyName: policyName
            }
        });
    }

    /**
     * @param policy - 
     * @param policyName - 
     */
    public async setPolicy(
        policy: TenantPolicy.Policy,
        policyName: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/TenantPolicy/Policies/{policyName}",
            routeValues: {
                policyName: policyName
            },
            body: policy
        });
    }

    /**
     * @param policyName - 
     */
    public async getPolicyInfo(
        policyName: string
        ): Promise<TenantPolicy.PolicyInfo> {

        return this.beginRequest<TenantPolicy.PolicyInfo>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "_apis/TenantPolicy/PolicyInformation/{policyName}",
            routeValues: {
                policyName: policyName
            }
        });
    }

}

export const TenantPolicyClientName = "ITenantPolicyRestClient";

export function getTenantPolicyClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITenantPolicyRestClient {
    return pageContext.getRestClient<ITenantPolicyRestClient>(TenantPolicyClientName, options);
}

RestClients.add(TenantPolicyClientName, { 
    factory: TenantPolicyRestClient,
    options: {
        serviceInstanceType: "951917ac-a960-4999-8464-e3f0aa25b381"
    }
});
